import * as React from 'react';
import { UIHeading3, Body1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IAlertProps {
  icon: React.ReactElement;
  title?: string;
  message: string | React.ReactElement;
  testId: string;
}

// Сейчас используется только 1 вариант алертов.
// При необходимости стоит сделать компонент более гибким.
export const Alert: React.FC<IAlertProps> = ({ icon, title, message, testId }) => {
  return (
    <div className={styles['container']} data-testid={testId}>
      <div className={styles['icon-area']}>{icon}</div>
      <div className={styles['content-area']}>
        {title && (
          <div className={styles['title-area']}>
            <UIHeading3>{title}</UIHeading3>
          </div>
        )}
        <Body1>{message}</Body1>
      </div>
    </div>
  );
};
